import React from 'react'

interface Props {
  label: string
  resultCount: number
}

const SearchResultHeading: React.FC<Props> = ({ label, resultCount }) => (
  <div className="text-secondary mb-0 text-lg">
    {label} ({resultCount})
  </div>
)

export default SearchResultHeading
